<template>
    <template v-if="pdict && Object.keys(pdict).length > 0">
        <ByosNavigation v-if="!hideComponent"/>
        <ByosChooseCategory v-if="!hideComponent"/>
        <ByosSuccess />
    </template>
</template>

<script setup>
import ByosNavigation from '@/components/byos/ByosNavigation.vue';
import ByosChooseCategory from '@/components/byos/ByosChooseCategory.vue';
import ByosSuccess from '@/components/byos/ByosSuccess.vue'
import { onMounted, nextTick, ref } from 'vue';
import { mapGetters, mapActions, mapMutations } from "@/store/helper/vuex";
import { EventBus as oldEventBus } from "@/scripts/event-bus.js";
import { useI18n } from 'vue-i18n';


const { pdict, boxProducts, totalAddedProducts, currentStage } = mapGetters();
const { addProduct, removeProduct, updateVuexWithByosSessionStorageData, setByosSessionStorage, setVueVariables } = mapMutations();
const { onSetCurrentStage, getBoxToEdit, removeBYOSStorageOnSiteChange } = mapActions();
const { t } = useI18n();

const hideComponent = ref(false);
const maxAddbox = 4;

oldEventBus.$on('removeProductFromBox', (productId) => {
    onRemoveProductFromBox(productId);
});

document.addEventListener('update-cart-variables', (event) => {
    setVueVariables(event.detail);
});

setVueVariables(window.vue.variables);

const onRemoveProductFromBox = (productId) => {
    removeProduct(productId);
    const addToBoxBtn = document.querySelector(`.add-to-box[data-pid="${productId}"]`);
    if (addToBoxBtn) {
        addToBoxBtn.dataset.productAdded = false;
    }
    if (boxProducts.value.length === 0 && currentStage !== 'category') {
        onSetCurrentStage('category');
    }
    setByosSessionStorage();
    refreshProductTiles();
}

const refreshProductTiles = function () {
    if (totalAddedProducts.value < 4) {
        window.EventEmitter && window.EventEmitter.emit('byosTile:removeDisabledClass');
    } else {
        const addedProducts = boxProducts.value.map(product => product.id);
        window.byosAddedProducts = addedProducts;
        window.EventEmitter && window.EventEmitter.emit('byosTile:toggleDisabledClass', addedProducts);
    }
};

const addAndRemoveProductsToBox = () => {
    document.addEventListener('click', (e) => {
        var btnElement = e.target.closest('.add-to-box');
        if (btnElement) {
            if (btnElement.classList.contains('open-quickview')) {
                btnElement.closest('.product-tile').querySelector('.quickview').dispatchEvent(new Event('click', { bubbles: true, cancelable: true }));
            } else {
                const addToBox = btnElement.dataset.addToBox || 'true';
                const productId = btnElement.dataset.pid;
                const tileAddToBoxBtn = document.querySelector(`.product-tile .add-to-box[data-pid=${productId}]`) || document.querySelector(`.product-quickview .add-to-box[data-pid=${productId}]`);
                const addToCartActionsEl = btnElement.closest('.quantity-add-to-cart-actions');
                const qtySelectorEl = addToCartActionsEl && addToCartActionsEl.querySelector('.quantity-select option:checked');
                const quantityToAdd = parseInt(qtySelectorEl && qtySelectorEl.value || 1);

                $('body').spinner().start();

                const qtyEle = document.querySelector('.quick-view .threshold-qty-msg');
                if (qtyEle) { qtyEle.innerHTML = ''; }
                if (quantityToAdd + totalAddedProducts.value <= maxAddbox) {
                    if (addToBox === 'true') {
                        addProduct({
                            id: productId,
                            qty: quantityToAdd || 1,
                            name: tileAddToBoxBtn.dataset.productName || '',
                            image: tileAddToBoxBtn.dataset.productImgUrl || '',
                            price: tileAddToBoxBtn.dataset.productPrice || '',
                            priceValue: Number(tileAddToBoxBtn.dataset.productPriceValue || 0)
                        });
                    } else {
                        removeProduct(productId);
                        btnElement.dataset.productAdded = false;
                    }
                    setByosSessionStorage();
                    const quickViewEl = btnElement.closest('.quick-view');
                    quickViewEl && $(quickViewEl.querySelector('.quickview-close')).trigger('click');
                } else {
                    if (addToBox === 'false') {
                        removeProduct(productId);
                        setByosSessionStorage();
                        btnElement.dataset.productAdded = false;
                    } else {
                        qtyEle.innerHTML = `<div class="qty-error" style="color: #c8102e; padding-top: 10px;">${t('max.products.added', [maxAddbox])}</div>`;
                    }
                }

                refreshProductTiles();
                $('body').spinner().stop();
            }
        }
    });
}

const addProductToBoxRedesign = (data) => {
    if ((totalAddedProducts.value + 1) > maxAddbox) {
        return;
    }

    $('body').spinner().start();

    addProduct({
        id: data.pid,
        qty: 1,
        name: data.productName || '',
        image: data.productImgUrl || '',
        price: data.productPrice || '',
        priceValue: Number(data.productPriceValue || 0)
    });
    setByosSessionStorage();
    refreshProductTiles();

    $('body').spinner().stop();
}

const removeProductToBoxRedesign = (data) => {
    $('body').spinner().start();

    removeProduct(data.pid);
    setByosSessionStorage();
    refreshProductTiles();

    $('body').spinner().stop();
}

const refreshProductTilesRedesign = () => {
    setTimeout(refreshProductTiles, 0);
}

onMounted(() => {
    const loadingBlock = document.getElementById('loading-block');
    removeBYOSStorageOnSiteChange();
    updateVuexWithByosSessionStorageData();

    if (pdict.value.action === 'edit') {
        getBoxToEdit().then((response) => {
            refreshProductTiles();
            if (response.success) {
                loadingBlock && loadingBlock.classList.add('d-none');
            } else {
                hideComponent.value = true;
            }
        });
    } else {
        loadingBlock && loadingBlock.classList.add('d-none');
        if (boxProducts.value.length === 0 && currentStage !== 'category') {
            onSetCurrentStage('category');
        }
        refreshProductTiles();
    }

    addAndRemoveProductsToBox();
    document.addEventListener('search:DOMUpdated', () => {
        refreshProductTiles();
    });
    nextTick(() => {
        document.dispatchEvent(new CustomEvent('byos:mounted'));
    });

    window.EventEmitter?.emit('PageMgr:contentUpdated');
    refreshProductTilesRedesign();
    window.EventEmitter?.on('byos:addProduct', addProductToBoxRedesign, this);
    window.EventEmitter?.on('byos:removeProduct', removeProductToBoxRedesign, this);
    window.EventEmitter?.on('byos:refresh', refreshProductTilesRedesign, this);
});

</script>